import React from 'react';

export const TablaUserFeecback = (props) => {
	/* Destructuring the props object. */
	const {headTablaUserFeecback, contentTablaUserFeedback, tamHead, titleTabla} = props;
	return (
		<div className='TablaUF'>
			<div className='titleTablaUserFeedback'>
				<div>
					<h4>{titleTabla}</h4>
				</div>
				<div className='showAllTablaUserFeedback'>Show all</div>
			</div>
			<div className='contentTablaUserFeedback'>
				<table className='tablaUserFeedback'>
					<tr className='headTablaUserFeedback'>
						{headTablaUserFeecback.map((head, id) =>
							id === 0 ? (
								<th className='elementHeadTablaUserFeedback pr'>
									<div className='elementTH'>
										<div>{head}</div>
									</div>
								</th>
							) : id === tamHead - 1 ? (
								<th className='elementHeadTablaUserFeedback ul'>
									<div className='elementTH'>
										<div>{head}</div>
									</div>
								</th>
							) : (
								<th className='elementHeadTablaUserFeedback'>
									<div className='elementTH'>
										<div>{head}</div>
									</div>
								</th>
							)
						)}
					</tr>
					{contentTablaUserFeedback.map((tipo, id) => (
						<tr
							key={id}
							className='tdTablaUserFeedback'
						>
							{tipo.map((element, id) => (
								<td
									key={id}
									className='contentTdTablaUserFeedback'
								>
									<div className='elementTD'>
										<div>{element}</div>
									</div>
								</td>
							))}
						</tr>
					))}
				</table>
			</div>
		</div>
	);
};
